export const REGISTER = "Register/REGISTER";
export const REGISTER_ERROR = "Register/REGISTER_ERROR";
export const REGISTER_LOADING = "Register/REGISTER_LOADING";